import React from 'react'
import {Link} from 'react-router'
import {CoreContext} from 'bundles/core/CoreContext'

// Context-aware link component
//
// This component will render a react-router pushState link if the following
// conditions are met:
//
// 1. A `to` prop is provided
// 2. The current entry bundle into the app is `core`
//
// Otherwise, a standard anchor tag will be rendered

export class CoreLink extends React.PureComponent {
  render () {
    const {to, href, ...props} = this.props
    return (
      <CoreContext.Consumer>
        {isCore => (isCore && to)
          ? <Link to={to} {...props} />
          : <a href={href || to} {...props} />}
      </CoreContext.Consumer>
    )
  }
}
